const RESOURCES_ES = {
  AIPR: "AIPR",
  BTP_PRO_CARD: "Tarjeta Profesional BTP",
  CACES: "CACES",
  CE_CERTIFICATE: "Certificado CE",
  CE_CERTIFICATION: "Certificación CE",
  DELIVERY: "Entrega",
  DEPARTURE_NOTE: "Nota de salida",
  DRIVING_AUTHORIZATION: "Autorización de Conducción",
  DUE: "Vencido",
  documentsStatus: "Estado de los documentos",
  EMAILS: "Correo electrónico",
  HOUR_SHEET: "Hojas de horas",
  ICON: "Icono",
  ID: "ID",
  IDENTITY: "Identidad",
  INSURANCE: "Seguro",
  INVOICE: "Factura",
  KBIS: "Kbis",
  LIFTING_PLAN: "Plan de Elevación",
  LIFTING_SHEET: "Hoja de Elevación",
  LOGO: "Logotipo",
  MACHINE_SPECIFICATIONS: "Especificaciones de la Máquina",
  MAINTENANCE_LOG: "Registro de Mantenimiento",
  MAINTENANCE_LOG_EXCERPT: "Extracto del Registro de Mantenimiento",
  MEDICAL_CERTIFICATE: "Certificado Médico",
  OPERATOR_DOCUMENT: "Documento del Operador",
  OTHER: "Otro",
  PGI: "PGI",
  PHOTO: "Foto",
  PIC: "PIC",
  PURCHASE_ORDER: "Orden de Compra",
  QUOTATION: "Presupuesto",
  RETURN_NOTE: "Nota de devolución",
  RIB: "RIB",
  SIGNED_RENTAL_REQUEST: "Solicitud de Alquiler Firmada",
  SPECIFIC_TRAINING: "Formación Específica",
  TECHNICAL_SHEET: "Ficha Técnica",
  USED_MACHINE_CERTIFICATE: "Certificado de Máquina Usada",
  USER_MANUAL: "Manual de Usuario",
  VGP: "VGP",
  WORK_ORDER: "Orden de trabajo",
} as const;

export default RESOURCES_ES;
